export const SITE = {
  company: "Top Service for Supplies and Imports",
  short: "Top Service",
  email: "m.marzouk@topservice-alex.com",
  mailto: "mailto:m.marzouk@topservice-alex.com",
  website: "www.topservicesalex.com",
  websiteUrl: "https://www.topservicesalex.com",
  phones: ["01223441421", "01203238837"],
  address: {
    street: "149 Thabit bin Qurra Street, Wardian",
    city: "Alexandria",
    country: "Egypt",
  },
};

export const IMAGES = {
  heroShip:
    "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  heroContainers:
    "https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aboutPort:
    "https://images.unsplash.com/photo-1578575437130-527eed3abbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse:
    "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
